module.exports = __webpack_public_path__ + "img/11.ee0a065b.png";